import {
    bexHttpClient
} from '../../clients';
import {
    GetOrganizationSubscriptionResponse,
    CreateCheckoutSessionResponse
} from '../bexService.types';

/**
 * Service class for performing subscription operations.
 */
class SubscriptionService {

    /**
     * Fetches organization subscription.
     * @param {string} organizationId - The organization ID.
     * @returns {Promise<GetOrganizationSubscriptionResponse>} The response from the server returns organization subscription.
     */
    async getOrganizationSubscription(organizationId: string): Promise<GetOrganizationSubscriptionResponse> {
        const response = await bexHttpClient.get(`/db/subscriptions/get-organization-subscription/${organizationId}`);
        return response;
    }

    /**
     * Fetches the organization subscriptions.
     * @returns {Promise<any[]>} The response from the server returns organization subscriptions.
     */
    async getOrgSubscriptions(organizationId) {
        const response = await bexHttpClient.get(`/db/subscriptions/get-subscriptions-by-organization/${organizationId}`);
        return response;
    }

    /**
     * Creates a checkout session for a subscription.
     * @param {string} organizationId - The organization ID.
     * @param {string} subOrganizationId - The sub-organization ID.
     * @param {string} priceId - The price ID for the subscription.
     * @param {boolean} isTrial - Whether the subscription is a trial.
     * @returns {Promise<CreateCheckoutSessionResponse>} The response from the server returns the checkout session.
     */
    async createCheckoutSession(organizationId: string, subOrganizationId: string, priceId: string, isTrial: boolean): Promise<CreateCheckoutSessionResponse> {
        const response = await bexHttpClient.post('/db/subscriptions/create-checkout-session', {}, {
            params: {
                organizationId: organizationId,
                subOrganizationId: subOrganizationId,
                priceId,
                isTrial,
            }
        });
        return response;
    }
}

const subscriptionService = new SubscriptionService();
export { subscriptionService };